import { NEWS_FETCH_ARTICLES_DATA, NEWS_CLEAR, NEWS_SEARCH_ARTICLES_DATA } from '../constants/news';
import { FAIL, START, SUCCESS } from '../constants';
import { addJavaHeaders } from '../utils';

export const startFetchingArticlesData = () => ({ type: NEWS_FETCH_ARTICLES_DATA + START });

export const setArticlesData = (articlesData) => ({
	type: NEWS_FETCH_ARTICLES_DATA + SUCCESS,
	payload: articlesData,
});

export const fetchingArticlesDataError = () => ({ type: NEWS_FETCH_ARTICLES_DATA + FAIL });

export const clearState = () => ({
	type: NEWS_CLEAR,
});

export const fetchNewsData =
	(page: number = 0) =>
	async (dispatch, getState, { fetch }) => {
		const {
			token: { token },
		} = getState();

		dispatch(startFetchingArticlesData());

		const fetchUrl = '/lexsApi/content/news/list';
		const fetchOptions = {
			method: 'POST',
			...addJavaHeaders(token),
			body: JSON.stringify({
				page,
				count: 30,
			}),
		};

		return fetch(fetchUrl, fetchOptions)
			.then((data) => data.json())
			.then(({ data }) => {
				dispatch(setArticlesData(data));
			})
			.catch((reason) => {
				dispatch(fetchingArticlesDataError());
				console.error(reason);
			});
	};

export const fetchSearchNewsData =
	(searchString) =>
	async (dispatch, getState, { fetch }) => {
		dispatch({ type: NEWS_SEARCH_ARTICLES_DATA + START });
		const searchURL = '/lexsApi/search/content';
		const body = {
			type: 'news',
			searchString,
		};

		return fetch(searchURL, {
			method: 'POST',
			body: JSON.stringify(body),
		})
			.then((data) => data.json())
			.then(({ data }) => {
				dispatch({ type: NEWS_SEARCH_ARTICLES_DATA + SUCCESS, payload: data });
			})
			.catch((reason) => {
				dispatch({ type: NEWS_SEARCH_ARTICLES_DATA + FAIL, payload: reason });
				console.error(reason);
			});
	};
